import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { Validators, FormControl } from "@angular/forms";
import { CommonFunctionService ,UserPOSData} from "../../../../services/Common/common-function.service";
import { PaymentService } from 'src/app/POS/POSServices/Setup/payment.service';
const swal = require('sweetalert');
@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss']
})
export class PaymentComponent implements OnInit {
  isReadytoUpdatepayment:boolean=false;
  merchantdata: UserPOSData ;
  dateTime;
  isNewpayment: boolean = true;
  isUpdatepayment: boolean = false;

  EnablePreAuth : boolean = false;
  AlwaysRequiredSignature: boolean = false;
  EnableFastPayWithCashRegister: boolean = false;
  LogOutAfterEachOrder: boolean = false;
  AlwaysRequiredManagerApprovalForRefund: boolean = false;

  rows;
  SetDefaultPreAuthAmount = new FormControl("", [Validators.required]);
  DontRequiredSignForTranUnderAmount = new FormControl("", [Validators.required]);
  ManagerApprovalRequiredForRefundAboveAmount = new FormControl("", [Validators.required]);
  id= new FormControl("", [Validators.required]);

  constructor(
    private router: Router,
    private commonfunction: CommonFunctionService,
     private service: PaymentService,
    private activatedRoute: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.merchantdata = this.commonfunction.getUserPOSData();
    this.getpaymentDetails();
  }
  getpaymentDetails() {
    let form = { merchantKeyId: "", id: "", PosSubscriptionId:"" };
    this.activatedRoute.params.subscribe(params => {
      console.log(params["id"]);
      console.log(params["merchantKeyId"]);
     form.id = params["id"];
      form.merchantKeyId = params["merchantKeyId"];
      form.PosSubscriptionId  = this.merchantdata.PosSubscriptionId;
      console.log("formdata---" + form);
    });   

    this.service.GetPaymentSetupDetail(form).subscribe(result => {   
      console.log("result.Id---" + result);
      if (result.id > 0) {
        this.dateTime=result.dateTime;
        this.EnablePreAuth =result.enablePreAuth ;
        this.AlwaysRequiredSignature =result.alwaysRequiredSignature ;
        this.EnableFastPayWithCashRegister =result.enableFastPayWithCashRegister ;
        this.LogOutAfterEachOrder =result.logOutAfterEachOrder ;
        this.AlwaysRequiredManagerApprovalForRefund =result.alwaysRequiredManagerApprovalForRefund ;
        this.isUpdatepayment = true;
        this.isNewpayment = false;
        this.rows = result;
      } else {
        this.isUpdatepayment = false;
        this.isNewpayment = true;
      }
    });
 
  }


  EnablePreAuth1() {
    this.EnablePreAuth =!this.EnablePreAuth ;
  }
  AlwaysRequiredSignature1() {
    this.AlwaysRequiredSignature =!this.AlwaysRequiredSignature ;
  }

  EnableFastPayWithCashRegister1() {
    this.EnableFastPayWithCashRegister =!this.EnableFastPayWithCashRegister ;
  }

  LogOutAfterEachOrder1() {
    this.LogOutAfterEachOrder =!this.LogOutAfterEachOrder ;
  }

  AlwaysRequiredManagerApprovalForRefund1() {
    this.AlwaysRequiredManagerApprovalForRefund =!this.AlwaysRequiredManagerApprovalForRefund ;
  }



  payment() {
    let form = {
      EnablePreAuth: false,
      AlwaysRequiredSignature: false,
      EnableFastPayWithCashRegister: false,
      LogOutAfterEachOrder: false,
      AlwaysRequiredManagerApprovalForRefund: false,
      PosSubscriptionId: "",
      SetDefaultPreAuthAmount: "",
      DontRequiredSignForTranUnderAmount: "",
      ManagerApprovalRequiredForRefundAboveAmount: "",
    };
    form.EnablePreAuth = this.EnablePreAuth;
    form.AlwaysRequiredSignature = this.AlwaysRequiredSignature;
    form.EnableFastPayWithCashRegister = this.EnableFastPayWithCashRegister;
    form.LogOutAfterEachOrder = this.LogOutAfterEachOrder;
    form.AlwaysRequiredManagerApprovalForRefund = this.AlwaysRequiredManagerApprovalForRefund;
    form.SetDefaultPreAuthAmount = this.SetDefaultPreAuthAmount.value;
    form.DontRequiredSignForTranUnderAmount = this.DontRequiredSignForTranUnderAmount.value;
    form.ManagerApprovalRequiredForRefundAboveAmount = this.ManagerApprovalRequiredForRefundAboveAmount.value;
    let merchantdata: UserPOSData = this.commonfunction.getUserPOSData();
    form.PosSubscriptionId = merchantdata.PosSubscriptionId;
    // alert(this.requestDate.value);
    // alert(this.dueDate.value);
    this.service.AddPaymentSetup(form).subscribe(result => {
      console.log(" result - ", result);
      if (result != null) {
        // this.dialog.open(SuccessPopupComponent, {
        //   data: " Add Payment Successfully !1"
        // });
        localStorage.removeItem('Paymentlist');
 swal("Added", "Add Payment Successfully ", "success"); 
        this.router.navigate(["/pos/payment/manage"]);
      }
    });
  }

  updatepayment()
  {
    let form = {
      Id:"",
      PosSubscriptionId: "",
      SetDefaultPreAuthAmount: "",
      DontRequiredSignForTranUnderAmount: "",
      ManagerApprovalRequiredForRefundAboveAmount: "",
      EnablePreAuth: false,
      AlwaysRequiredSignature: false,
      EnableFastPayWithCashRegister: false,
      LogOutAfterEachOrder: false,
      AlwaysRequiredManagerApprovalForRefund: false,   
      DateTime:"",
    };
    form.EnablePreAuth = this.EnablePreAuth;
    form.AlwaysRequiredSignature = this.AlwaysRequiredSignature;
    form.EnableFastPayWithCashRegister = this.EnableFastPayWithCashRegister;
    form.LogOutAfterEachOrder = this.LogOutAfterEachOrder;
    form.AlwaysRequiredManagerApprovalForRefund = this.AlwaysRequiredManagerApprovalForRefund;
    form.SetDefaultPreAuthAmount = this.SetDefaultPreAuthAmount.value;
    form.DontRequiredSignForTranUnderAmount = this.DontRequiredSignForTranUnderAmount.value;
    form.ManagerApprovalRequiredForRefundAboveAmount = this.ManagerApprovalRequiredForRefundAboveAmount.value;
    form.Id=this.id.value;
    form.DateTime=this.dateTime;
    let merchantdata: UserPOSData = this.commonfunction.getUserPOSData();
    form.PosSubscriptionId = merchantdata.PosSubscriptionId;
    this.service.UpdatePaymentSetup(form).subscribe(result => {
      console.log(" result - ", result);
      if (result != null) {
        // this.dialog.open(SuccessPopupComponent, {
        //   data: "Update Payment Successfully !1"
        // });
        localStorage.removeItem('Paymentlist');
        swal("Update", "Update Payment Successfully ", "success"); 
        this.router.navigate(["/pos/payment/manage"]);
      }
    });
  }
  onKey()
  {
    this.isReadytoUpdatepayment = true;
  }
  SetDefaultPreAuthAmountError() {
    return this.SetDefaultPreAuthAmount.hasError("required") ? "SetDefaultPreAuthAmount is required": "";
     // : this.SetDefaultPreAuthAmount.hasError("pattern") ? "First Name should be allow only alphabets" : "";
  }
  DontRequiredSignForTranUnderAmountError() {
    return this.DontRequiredSignForTranUnderAmount.hasError("required") ? "DontRequiredSignForTranUnderAmount is required": "";
     // : this.SetDefaultPreAuthAmount.hasError("pattern") ? "First Name should be allow only alphabets" : "";
  }
  ManagerApprovalRequiredForRefundAboveAmountError() {
    return this.ManagerApprovalRequiredForRefundAboveAmount.hasError("required") ? "ManagerApprovalRequiredForRefundAboveAmount is required": "";
     // : this.SetDefaultPreAuthAmount.hasError("pattern") ? "First Name should be allow only alphabets" : "";
  }
}
